/* istanbul ignore file */
export * from './useAddLastSeen';
export * from './useFormatedPrice';
export * from './useHashParameters';
export * from './useResponsiveAkamaiTemplate';
